module.exports = __webpack_public_path__ + "images/category_lp/earphone/assessment_achievements/2_5acea7cc1455421c5bdfae4c3a98ac69.jpg";